import _ from 'lodash'
import React from 'react'
import { Grid, Icon, Message, Popup, Segment, SemanticWIDTHS } from 'semantic-ui-react'
import {
  DEVELOPMENT_PERMIT_DOCUMENT_HOST,
  DEVELOPMENT_PERMIT_DOCUMENT_PATH,
  PLANNING_SERVICES_EMAIL,
  PLANNING_SERVICES_PHONE,
  PLANNING_SERVICES_PHONE_INTERNATIONAL,
} from '../../environment'
import HistoryDisclaimer from '../warning/HistoryDisclaimer'

import './PlanningApplications.css'
import { PlanningAppData } from './slice'

type props = {
  planningApps?: PlanningAppData[]
  labelWidth: SemanticWIDTHS
  valueWidth: SemanticWIDTHS
}

function PlanningApplications({ planningApps, labelWidth, valueWidth }: props) {
  const populateApplicationPurpose = (app: PlanningAppData) => {
    return (
      <React.Fragment>
        <Grid.Row className={'appDetailsRow'}>
          <Grid.Column width={labelWidth} className={'appFieldLabel'}>
            <div>
              Application Purpose :
            </div>
          </Grid.Column>
          <Grid.Column width={valueWidth}>
            <div>
              {app.applicationPurpose}
            </div>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    )
  }

  const populateApplicationStatus = (app: PlanningAppData) => {
    return (
      <React.Fragment>
        <Grid.Row className={'appDetailsRow'}>
          <Grid.Column width={labelWidth} className={'appFieldLabel'}>
            <div>
              Application Status :
            </div>
          </Grid.Column>
          <Grid.Column width={valueWidth}>
            <div>
              {app.applicationStatus}
            </div>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    )
  }

  const populateInstrumentSigned = (app: PlanningAppData) => {
    return (
      <React.Fragment>
        <Grid.Row className={'appDetailsRow'}>
          <Grid.Column width={labelWidth} className={'appFieldLabel'}>
            <div>
              Instrument Signed :
            </div>
          </Grid.Column>
          <Grid.Column width={valueWidth}>
            <div>
              {app.instrumentSigned}
            </div>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    )
  }

  const getDpNumberElement = (app: PlanningAppData) => {
    if (app.docsAvailable) {
      return (
        <div>
          <a href={DEVELOPMENT_PERMIT_DOCUMENT_HOST + DEVELOPMENT_PERMIT_DOCUMENT_PATH + app.appId + '?dpDocs'}
             target="_blank" rel="noopener noreferrer">{app.instrumentNumber}</a>
        </div>
      )
    }
    return (
      <div>
        <div className={'instrumentNumberDiv'}>
          {app.instrumentNumber}
        </div>
        <div className={'infoSignDiv'}>
          <Popup
            wide
            hoverable
            trigger={<Icon size={'small'} color={'blue'} name={'info'}
                           circular/>}>
            <Message info>
              <p>Contact <a href={'mailto: ' + PLANNING_SERVICES_EMAIL}>{PLANNING_SERVICES_EMAIL}</a>
                &nbsp;or phone: <a
                  href={'tel:' + PLANNING_SERVICES_PHONE_INTERNATIONAL}>{PLANNING_SERVICES_PHONE}</a> for
                the the documents</p>
            </Message>
          </Popup>
        </div>
      </div>
    )

  }

  const populateInstrumentNumber = (app: PlanningAppData) => {
    return (
      <React.Fragment>
        <Grid.Row className={'appDetailsRow'}>
          <Grid.Column width={labelWidth} className={'appFieldLabel'}>
            <div>
              Instrument Number :
            </div>
          </Grid.Column>
          <Grid.Column width={valueWidth}>
            {getDpNumberElement(app)}
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    )
  }

  const populateApplications = (app: PlanningAppData, i: number) => {
    return (
      <Segment key={i} className={'planningAppSegment'} vertical>
        <Grid className={'planningAppGrid'}>
          {populateApplicationPurpose(app)}
          {populateApplicationStatus(app)}
          {populateInstrumentSigned(app)}
          {populateInstrumentNumber(app)}
        </Grid>
      </Segment>
    )
  }

  const displayPlanningData = () => {
    if (_.isEmpty(planningApps)) {
      return (
        <React.Fragment>
          <Message className={'noAppMsg'} info content={'No planning applications found'}/>
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        {planningApps && planningApps.map((a, i) => populateApplications(a, i))}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <div className={'applicationsSubject'}>
        <h3 className={'appHeader'}>Planning Applications </h3>
        <Popup
          wide
          hoverable
          trigger={<p className={'historyDisclaimer'}>(Development History <b>Disclaimer</b>)</p>}
          content={<HistoryDisclaimer/>}
        />
      </div>
      {displayPlanningData()}
    </React.Fragment>
  )
}

export default PlanningApplications